<template>
	<v-card-text class="mt">
		<v-toolbar color="blue" class="white--text">
			<v-icon color="white">person</v-icon>
			<v-toolbar-title>Dane osobowe</v-toolbar-title>
			<v-spacer></v-spacer>
		</v-toolbar>
		<v-btn v-if="editable" color="primary" class="mt-3 ml-3 white--text" dark @click="readOnlyMode = !readOnlyMode">
			<v-icon class="ml-1 mr-3">{{ icon }}</v-icon>
			{{ buttonLabel }}
		</v-btn>
		<div class="ma-4">
			<v-layout row>
				<v-flex xs1/>
				<v-flex xs2>
					<v-subheader>E-mail</v-subheader>
				</v-flex>
				<v-flex xs6>
					<v-text-field
						browser-autocomplete="off"
						solo
						readonly
						v-model="data.email"
						aria-label="label for email">
					</v-text-field>
				</v-flex>
			</v-layout>
			<v-layout row>
				<v-flex xs1/>
				<v-flex xs2>
					<v-subheader>Imię</v-subheader>
				</v-flex>
				<v-flex xs6>
					<v-text-field
						browser-autocomplete="off"
						data-vv-name="name"
						data-vv-as="Imię"
						:readonly="readOnlyMode"
						:error-messages="vErrors.collect('personalDataScope.name')"
						v-model="data.name"
						v-validate="'required'"
						data-vv-scope="personalDataScope"
						aria-label="label for name">
					</v-text-field>
				</v-flex>
			</v-layout>
			<v-layout row>
				<v-flex xs1/>
				<v-flex xs2>
					<v-subheader>Nazwisko</v-subheader>
				</v-flex>
				<v-flex xs6>
					<v-text-field
						browser-autocomplete="off"
						data-vv-name="surname"
						data-vv-as="Nazwisko"
						:readonly="readOnlyMode"
						:error-messages="vErrors.collect('personalDataScope.surname')"
						v-model="data.surname"
						v-validate="'required'"
						data-vv-scope="personalDataScope"
						aria-label="label for surname">
					</v-text-field>
				</v-flex>
			</v-layout>
			<v-layout row>
				<v-flex xs1/>
				<v-flex xs2>
					<v-subheader>Telefon</v-subheader>
				</v-flex>
				<v-flex xs6>
					<v-text-field
						browser-autocomplete="off"
						data-vv-name="phoneNumber"
						data-vv-as="Telefon"
						:readonly="readOnlyMode"
						:error-messages="vErrors.collect('personalDataScope.phoneNumber')"
						v-model="data.phoneNumber"
						v-validate="{required: true, regex: /^[0-9 +-]*$/}"
						data-vv-validate-on="none"
						data-vv-scope="personalDataScope"
						aria-label="label for phone">
					</v-text-field>
				</v-flex>
			</v-layout>
			<v-layout row>
				<v-flex xs1/>
				<v-flex xs2>
					<v-subheader>E-mail kontaktowy</v-subheader>
				</v-flex>
				<v-flex xs6>
					<v-text-field
						browser-autocomplete="off"
						data-vv-name="bidderContactMail"
						data-vv-as="E-mail kontaktowy"
						:readonly="readOnlyMode"
						:error-messages="vErrors.collect('personalDataScope.bidderContactMail')"
						v-model="data.bidderContactMail"
						v-validate="'required|email'"
						data-vv-validate-on="none"
						data-vv-scope="personalDataScope"
						aria-label="label for email">
					</v-text-field>
				</v-flex>
			</v-layout>
		</div>
	</v-card-text>
</template>

<script>
	export default {
		name: "PersonalProfileDataView",

		data() {
			return {
				readOnlyMode: true,

				data: {},
			};
		},

		watch: {
			personalData: function () {
				this.data = this.personalData;
			},

			readOnlyMode: function (value) {
				if (value) {
					this.$validator.validateAll("personalDataScope").then(result => {
						if (result) {
							this.$emit("edition-status", !value);
						} else {
							this.readOnlyMode = !this.readOnlyMode;
						}
					});
				} else {
					this.$emit("edition-status", !value);
				}
			},
		},

		computed: {
			icon() {
				return this.readOnlyMode ? "edit" : "save";
			},

			buttonLabel() {
				return this.readOnlyMode ? "Edytuj" : "Skończ edycję";
			},
		},

		props: {
			personalData: Object,
			editable: {
				default: true,
			},
		},
	};
</script>

<style scoped>

</style>